<script>
    // import { navigate } from 'svelte-routing';
    // if (!localStorage.getItem("authUser")) {
    //   navigate('/login');
    // }
    
    import {
      Container,
      Row,
      Col,
      
    } from "sveltestrap";
  
    
    import Poster from "./Poster.svelte";
    import Notice from "./Notice.svelte";
    
  
  </script>
  
  <div class="page-content">
    <Container fluid>
      <!-- <Breadcrumbs title="홈" breadcrumbItem="Dashboard" /> -->
      
      <Row>
        <Col lg="6">
            <Notice />
        </Col>        
        <Col lg="6">    
            <Poster />
        </Col>          
    </Row>
      
    </Container>
  </div>
  